Object.defineProperty(exports, "__esModule", {
  value: true
});

function FilteredQuery(filtered) {
  return {
    filtered: filtered
  };
}

exports.FilteredQuery = FilteredQuery;